<template>
    <div id="answer-reports">
        <div class="content">
         <!--   <div class="row">
                <span class="f14">标题</span>
                <a-input v-model="searchReportName" class="search-input" size="small"/>
                <span class="f14">日期</span>
                &lt;!&ndash; 日历 &ndash;&gt;
                <a-date-picker
                        class="search-input"
                        size="small"
                        placeholder="请输入创建日期"
                        v-model="momentDate"
                        @change="datePickerChange"
                />
                <span class="f14">类型</span>
                <a-select
                        class="search-input"
                        v-model="searchReleaseType"
                        size="small"
                >
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option value="0">草稿</a-select-option>
                    <a-select-option value="1">定稿</a-select-option>
                </a-select>

                <a-button class="btn" type="primary" size="small" @click="onSearch">查询</a-button>

                <a-button
                        class="btn"
                        type="primary"
                        @click="openAddReport"
                        size="small"
                >
                    新建解读报告
                </a-button>
                <a-select
                        v-if="selectNums"
                        v-model="selectModel"
                        style="width: 120px"
                        size="small"
                        @change="selectModelChange"
                >
                    <a-select-option value="delete">
                        <a-icon type="delete" style="margin-right:15px"/>
                        删除
                    </a-select-option>
                    &lt;!&ndash; <a-select-option value="finalize"><a-icon type="file-done" style="margin-right:15px" />定稿</a-select-option> &ndash;&gt;
                </a-select>
            </div>-->
            <div class="reportHead">
                <div class="reportSearchBox">
                    <div class="reportSearch">
                        <div class="searchPicker">
                            {{PickerList[PickerIndex].name}}
                            <div class="pickerIcon icon el-icon-caret-bottom"></div>
                            <div class="PickerList">
                                <div class="PickerItem" v-for="(item,index) in PickerList" :key="index" @click="pickerChange(index)"> {{item.name}} </div>
<!--                                <div class="PickerItem">时间</div>-->
                            </div>
                        </div>
                        <div class="searchInput">
                            <input v-if="PickerIndex===0" v-model="searchReportName" type="text" placeholder="输入主题">
                            <input v-if="PickerIndex===1" v-model="searchDate" type="text" placeholder="输入创建时间 格式为:2021-01-01">
                        </div>
                        <div class="searchBtn" @click="onSearch">
                            <div class="icon el-icon-search"></div>
                        </div>
                    </div>
                    <div class="reportAddBtn" @click="openAddReport">新建解读报告</div>
                </div>
            </div>
            <a-table
                    v-if="reports"
                    :columns="columns"
                    :dataSource="reports"
                    :rowClassName="rowClassName"
                    :rowSelection="{
                    'onSelect':onSelect,
                    'onSelectAll':onSelectAll
                }"
                    :pagination="pagination"
            >
<!--                <div slot="img" slot-scope="coverImageUrl" class="img-wrap">-->
<!--                    <img v-if="coverImageUrl" :src="coverImageUrl | imgUrl(2) "/>-->
<!--                </div>-->
                <div slot="reportName" slot-scope="reportName" class="title text-overflow">
                    {{reportName}}
                </div>
                <div slot="releaseType" slot-scope="releaseType" class="type">
                    <span v-if="releaseType">
                        定稿
                    </span>
                    <span v-else>草稿</span>
                </div>
                <div slot="operation" slot-scope="operation,dataItem" class="type">
                    <template v-if="operation">
                        <a @click="viewReport(dataItem)">查看</a>
                    </template>
                    <template v-else>
                        <a @click="editReport(dataItem)" style="margin-right:10px;">编辑</a>
                        <a-popconfirm title="确认要删除本条报告吗？" @confirm="itemDeleteReport(dataItem)">
                            <a-icon slot="icon" type="question-circle-o" style="color: red"/>
                            <a>删除</a>
                        </a-popconfirm>
                    </template>
                </div>
            </a-table>

            <a-empty v-else/>
        </div>
        <AddReportModal
                v-if="showAddReport"
                :show.sync="showAddReport"
                :cityOptions="cityOptions"
        />
    </div>
</template>

<script>
    import UrlApi from "@/utils/UrlApi.js";
    import AddReportModal from "./AddReportModal.vue";

    export default {
        name: "AnswerReports",
        data() {
            return {
                reports: null,
                columns: [
                    {title: '全选', dataIndex: 'index', key: 'index', width: '7%'},
                    // {
                    //     title: '缩略图', dataIndex: 'coverImageUrl', key: 'coverImageUrl', width: '15%',
                    //     scopedSlots: {customRender: 'img'}
                    // },
                    {
                        title: '报告标题', dataIndex: 'reportName', key: 'reportName', width: '35%',
                        scopedSlots: {customRender: 'reportName'}
                    },
                    {title: '城市', dataIndex: 'city', key: 'city', width: '10%',},
                    {title: '时间', dataIndex: 'timePoint', key: 'timePoint', width: '20%'},
                    {
                        title: '报告类型', dataIndex: 'releaseType', key: 'releaseType', width: '10%',
                        scopedSlots: {customRender: 'releaseType'}
                    },
                    {
                        title: '操作', dataIndex: 'operation', key: 'operation', width: '15%',
                        scopedSlots: {customRender: 'operation'}
                    }
                ],
                pagination: {
                    page: 1,
                    pageSize: 7,
                    totalPage: 0,
                    total: 0,
                    onChange: (page) => this.pageChange(page)
                },
                momentDate: null,
                searchDate: null,
                searchReportName: "",
                cityOptions: null,
                searchCity: [],
                searchReleaseType: "",
                showAddReport: false,
                selectReportIds: [],
                selectModel: "批量操作",
                searchDateRangeType: "0",
                openSelectModel: false,

                PickerList:[
                    {name:'主题',id:1},
                    {name:'时间',id:2},
                ],
                PickerIndex:0


            };
        },
        watch: {
            showAddReport(val) {
                if (!val) {
                    this.getReportListData();
                }
            }
        },
        components: {
            AddReportModal
        },
        created() {
            this.getReportListData();
            this.getAllProvince();
        },
        computed: {
            selectNums() {
                return this.selectReportIds.length;
            }
        },
        methods: {
            pickerChange(index){
                this.PickerIndex= index
                this.searchReportName =''
                this.searchDate =''
                this.onSearch()
            },
            // 批量操作
            selectModelChange(val) {
                let _this = this;
                if (val === "delete") {
                    // this.$confirm({
                    //     title: '确定要执行批量删除操作吗？',
                    //     onOk() {
                    //         _this.deleteReports();
                    //     },
                    //     onCancel() {
                    //
                    //     }
                    // });

                    this.$confirm('确定要执行批量删除操作吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        _this.deleteReports();
                    }).catch(() => {

                    });
                }
                this.selectModel = "批量操作"
            },
            // 编辑单个解读报告
            editReport(itemReport) {
                let {id} = itemReport;
                this.$router.push({name: 'EditReport', query: {id: id}});
            },
            // 查看单个解读报告
            viewReport(itemReport) {
                let {id} = itemReport;
                this.$router.push({name: 'ViewReport', query: {id: id}});
            },
            // 点击单个删除操作
            itemDeleteReport(itemReport) {
                this.selectReportIds = [itemReport.id];
                this.deleteReports();
            },
            // 删除
            deleteReports() {
                let token = this.$store.getters.getToken;
                let url = UrlApi.deleteReport;
                let params = "ids=" + this.selectReportIds.join(",");
                this.$http.post(url, params, {
                    headers: {
                        "content-type": "application/x-www-form-urlencoded",
                        "Authorization": token
                    }
                }).then((res) => {
                    let message = res.data.message;
                    if (res.data.success) {
                        this.$message.success(message);
                        this.selectReportIds = [];
                        this.getReportListData();
                    } else {
                        this.$message.warning(message);
                    }
                })
            },
            // checkBox 点击全选 selected, selectedRows, changeRows
            onSelectAll(selected, selectedRows) {
                let arr = selectedRows.map(item => {
                    return item.id;
                })
                this.selectReportIds = arr;
            },
            // checkBox 选中变化
            onSelect(record, selected, selectedRows) {
                let arr = selectedRows.map(item => {
                    return item.id;
                })
                this.selectReportIds = arr;
            },
            // 打开解读报告
            openAddReport() {
                this.showAddReport = true;
            },
            // 城市切换
            onCityChange(val) {
                this.searchCity = val;
            },
            // load
            loadCityData(city) {
                let url = UrlApi.provinceCity;
                const targetOption = city[city.length - 1];
                targetOption.loading = true;
                let params = {
                    province: city[0].value
                }
                this.$http.get(url, {
                    params: params
                }).then((res) => {
                    targetOption.loading = false;
                    targetOption.children = [];
                    res.data.data.map((item) => {
                        let obj = {
                            label: item.name,
                            value: item.name
                        }
                        targetOption.children.push(obj)
                    })
                    this.cityOptions = [...this.cityOptions];
                })
            },
            // 获取全国信息
            getAllProvince() {
                let url = UrlApi.allProvince;
                this.$http.get(url).then((res) => {
                    this.cityOptions = [];
                    res.data.data.map((item) => {
                        let obj = {
                            value: item.name,
                            label: item.name,
                            isLeaf: false
                        }
                        if (item.value) {
                            delete obj.isLeaf;
                        }
                        this.cityOptions.push(obj);
                    })
                })
            },
            // 点击查询
            onSearch() {
                this.pageChange(1);
            },
            // 点击重置
            onClearAll() {
                this.pagination.page = 1;
                this.pagination.pageSize = 7;
                this.searchDate = null;
                this.momentDate = null;
                this.searchReleaseType = "";
                this.searchReportName = "";
                this.searchDateRangeType = "0";
                this.searchCity = [];
            },
            // 点击全部报告
            searchAll() {
                this.onClearAll();
                this.getReportListData()
            },
            // 日期选择
            datePickerChange(momentDate, date) {
                this.searchDate = date;
            },
            // table分页切换
            pageChange(page) {
                this.pagination.page = page;
                this.getReportListData();
            },

            rowClassName(record, index) {
                let className = 'dark';
                if (index % 2 === 1) className = 'light';
                return className;
            },
            // 获取解读数据列表
            getReportListData() {
                let url = UrlApi.getReportsLlist;
                let token = this.$store.getters.getToken;
                let userId = this.$store.getters.getUserId;
                let searchCity = this.searchCity.length ? this.searchCity[this.searchCity.length - 1] : "";
                this.$http.get(url, {
                    params: {
                        userId: userId,
                        reportName: this.searchReportName,
                        page: this.pagination.page,
                        // default 7
                        pageSize: this.pagination.pageSize,
                        //时间周期（0：全部，1：一周，2：一个月，3：三个月，4：半年，5：一年）
                        dateRangeType: this.searchDateRangeType,
                        city: searchCity,
                        // ""全部，0草稿 1定稿
                        releaseType: this.searchReleaseType,
                        // 格式2019-12-06
                        timePoint: this.searchDate
                    },
                    headers: {
                        "Authorization": token
                    }
                }).then((res) => {
                    this.reports = res.data.data.list;
                    if (this.reports && this.reports) {
                        this.reports.map((item, index) => {
                            item.index = index + 1;
                            item.key = item.id;
                            item.operation = item.releaseType;
                            //item.coverImageUrl = "http://49.233.189.220:8080/unsafe/asset/ep/app/thumbnail/气象成因_02气象参数空间插值图.png?v3"
                        })
                    }
                    let pageInfo = res.data.data.pageInfo;
                    this.pagination.page = pageInfo.page;
                    this.pagination.pageSize = pageInfo.pageSize;
                    this.pagination.total = pageInfo.total;
                    this.pagination.totalPage = pageInfo.totalPage;
                })
            }
        }
    }

</script>
<style lang="less" scoped>
    @import "exportList";

    /deep/    .ant-table .light{
            background-color: white;
        }
    /deep/    .ant-table .dark{
            background-color: rgb(240, 240, 241);
        }
    /deep/    .ant-table-thead > tr > th{
        padding: 16px 0 !important;
    }
    /deep/ .ant-table-tbody > tr > td{
        padding: 16px 0 !important;
    }




</style>